import { Lang } from 'enums';

export const getLang = (lang: string): Lang => {
  if (lang.toLowerCase().includes('en')) return Lang.EN;
  if (lang.toLowerCase().includes('uk')) return Lang.UK;
  return Lang.UK;
};
